import { render, staticRenderFns } from "./ContractTypeForm.vue?vue&type=template&id=6b7d121d"
import script from "./ContractTypeForm.vue?vue&type=script&lang=js"
export * from "./ContractTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ContractTypeForm.vue?vue&type=style&index=0&id=6b7d121d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports